const UserSearch = require('../../user-search/index');
const templates = {
  container: require('../ui/templates/modal/friends.hbs'),
  item: require('../ui/templates/modal/friends/template-item.hbs'),
  loading: require('../ui/templates/modal/friends/loading.hbs'),
  noResults: require('../ui/templates/modal/friends/no-results.hbs')
};

class ModalFriends {
  constructor (opts) {
    const that = this;

    this.opts = $.extend(
      {
        type: null, // admins, inked, tagged
        bookId: INKIVE.C.BOOK.id,
        bookName: Base64.decode(INKIVE.C.BOOK.name),

        baseUrl: INKIVE.C.BASE_URL,
        staticUrl: INKIVE.C.STATIC_URL
      },
      opts
    );

    this.$wrapper = $(
      this.opts.wrapper
        ? $(this.opts.wrapper)
        : $('<div class="tool-content"></div>')
    );

    initTemplate();
    initEmail();

    function initTemplate () {
      that.$wrapper.append(templates.container());
    }

    function initEmail () {
      const $email = that.$wrapper.find('#email4inviting');
      const $section = that.$wrapper.find('#inviteFriendComments').parent();

      $email.keyup(function (event) {
        const text = $(this).val().trim();
        const slideFunctionName =
          text.length > 0 && text.indexOf('@') > 0 ? 'slideDown' : 'slideUp';

        $section[slideFunctionName]('fast', function () {
          that.$wrapper.trigger('contentChanged');
        });
      });
    }
  }

  getFormHtml () {
    return this.$wrapper;
  }

  saveForm (callback) {
    callback = callback || $.noop;
    const that = this;

    const emails = that.$wrapper.find('#email4inviting').val();

    if (emails) {
      const params = {
        email: emails,
        message: that.$wrapper.find('#inviteFriendComments').val(),
        scrapbook_id: that.opts.bookId,
        scrapbook_name: that.opts.bookName,
        invite_type:
          that.opts.type == 'admins'
            ? 2
            : that.opts.type == 'inked'
              ? 1
              : that.opts.type == 'tagged'
                ? 3
                : null
      };

      $.post(that.opts.baseUrl + 'inkive/inkviaemail', params, function (data) {
        let editorProjectUrl =
          that.opts.baseUrl + 'editor/?id=' + that.opts.bookId;
        editorProjectUrl = encodeURI(editorProjectUrl);
        const disableExitOnSave = INKIVE.disableWindowExitConfirm;
        INKIVE.disableWindowExitConfirm = true;
        window.location.href =
          'mailto:' +
          that.$wrapper.find('#email4inviting').val() +
          '?body=' +
          editorProjectUrl;
        _.delay(function () {
          INKIVE.disableWindowExitConfirm = disableExitOnSave;
        }, 1000);
        that.$wrapper.find('#email4inviting').val('');
      }).error(function (e) {
        that.$wrapper.find('#email4inviting').val('');
      });
    }
  }

  deleteInvolvedUser ($elem, bookId, callback, baseUrl) {
    baseUrl = baseUrl || INKIVE.C.BASE_URL;
    bookId = bookId || INKIVE.C.BOOK.id;

    callback = callback || $.noop;

    const delete_params = {
      id: $elem.parents('.userHolder').data('id'),
      inkive_id: bookId
    };

    $.post(baseUrl + 'friends/unsetinked', delete_params, function (data) {
      const $listContainer = $elem.parents('.listContainer');
      $elem.parents('.userHolder').remove();

      if (!$listContainer.find('.userHolder').length) {
        $listContainer.parent().addClass('empty');
        $listContainer.find('.emptyText').show();
      }

      callback(bookId);
    });
  }

  initInvolvedList ($elem, type, onDelete, bookId, baseUrl) {
    baseUrl = baseUrl || INKIVE.C.BASE_URL;
    bookId = bookId || INKIVE.C.BOOK.id;

    onDelete = onDelete || $.noop;

    const listName = $elem.attr('class');

    const params = {
      type,
      scrapbook: bookId,
      currentPage: 'mykive'
    };

    const last_li = $elem.find('li:last');
    const $parent = $elem.parent().parent();

    $.getJSON(baseUrl + 'inkive/getInked', params).done(function (json) {
      $elem.find('li>:not(a)').parent().remove();
      $parent.find('.spinnerWrapper').hide();

      if (json.success) {
        const data = json.data;
        if (data.trim().length) {
          $elem.find('li>:not(a)').parent().remove();
          $elem.prepend(json.data);
          $('li[data-toggle="tooltip"]').tooltip({ placement: 'top' });

          $parent.removeClass('empty');
          $parent.find('.emptyText').hide();
        }

        if ($(last_li).attr('data-position') != null) {
          let new_width = $(last_li).attr('data-position') * 40;

          if (listName != 'co-creators-list') new_width = new_width + 40;

          $($elem).css('width', new_width);
        }

        $($elem).trigger('listupdate', bookId);
      }

      $elem.find('.thumb-img').unbind('mouseenter');
      $elem.on('mouseenter', '.thumb-img', function (e) {
        const $deleteImage = $(this).parent().find('.thumb-delete');

        if ($deleteImage.length > 0) {
          $(this).fadeOut();
          $deleteImage.fadeIn();
        }
      });

      $elem.find('.thumb-delete').unbind('mouseleave click');
      $elem.on('mouseleave', '.thumb-delete', function (e) {
        $(this).fadeOut();
        $(this).parent().find('.thumb-img').fadeIn();
      });

      $elem.on('click', '.thumb-delete', function (e) {
        onDelete($(this));
      });
    });
  }
}

module.exports = ModalFriends;
